import { render, staticRenderFns } from "./OfficeBuilding.vue?vue&type=template&id=42130036&scoped=true"
import script from "./OfficeBuilding.vue?vue&type=script&lang=js"
export * from "./OfficeBuilding.vue?vue&type=script&lang=js"
import style0 from "./OfficeBuilding.vue?vue&type=style&index=0&id=42130036&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42130036",
  null
  
)

export default component.exports